module.exports = __webpack_public_path__ + "img/geminggushi@3x.18bbad1c.png";